import { render, staticRenderFns } from "./replies.vue?vue&type=template&id=168661f5&scoped=true&"
import script from "./replies.vue?vue&type=script&lang=js&"
export * from "./replies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168661f5",
  null
  
)

export default component.exports